
<template>
    <b-card no-body>
        
            <b-modal id="create-or-update" size="lg" :title="editing ? 'Güncelle' : 'Oluştur'" scrollable no-close-on-esc no-close-on-backdrop>
                <branch-create-or-update v-model="branch" :errors="errors"></branch-create-or-update>
                <template #modal-footer><v-executer :loading="loading" :editing="editing" :action="createOrUpdate"></v-executer></template>
            </b-modal>
        
            <v-table    ref="table"
                        :buttons="buttons"
                        :fields="fields"
                        name="branch"
                        pagination="server"
                        search
                        :items-provider="provider"
                        :add-callback="createNew"></v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import BranchCreateOrUpdate from './components/BranchCreateOrUpdate.vue'
import CompanyApi from '@/api/company'
export default {
    components:{
        BCard,
        BranchCreateOrUpdate
    },
    data(){
        return{
            fields:[
                {name:"Şube",key:"Name", thClass:"w-20",sortable:true},
                {name:"İl",key:"AddressProvince", thClass:"w-10",sortable:true},
                {name:"İlçe",key:"AddressDistrict", thClass:"w-10",sortable:true},
                {name:"Şube Tipi",key:"BranchTypeName",sortKey:'BranchType.Name', thClass:"w-15",sortable:true},
                {name:"Sicil Numarası",key:"RegistryNumber", thClass:"w-10",sortable:true},
                {name:"Hafta Tatili",key:"OffDayStr", thClass:"w-15",sortable:true},
                {name:"Aktif",key:"IsActive", thClass:"w-5",sortable:true},   
                {name:"Yurtdışı Şubesi",key:"IsAbroad", thClass:"w-5",sortable:true},   
                {name:"Puantaj Sorumlusu",key:"EmployeeFullName", thClass:"w-10",sortable:true},  
                {name:"Şube Sorumlusu",key:"ManagerEmployeeFullName", thClass:"w-10",sortable:true},  
                {name:"Tehlike Sınıfı",key:"HazardClassName", thClass:"w-10",sortable:true},  
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
            ],
            editing:false,
            errors:{},
            loading:false,
            branch:{
                Id:null,
                Name:null,
                IsActive:true,
                RegistryNumber:null,
                TaxNumber:null,
                BranchTypeId:null,
                IsAbroad:null,
                SGKBranchUsername:null,
                SGKBranchCode:null,
                SGKBranchPassword:null,
                SGKSystemPassword:null,
                Address:null,
                AddressDistrictId:null,
                AddressProvinceId:null,
                EmployeeId:null,
                EmployeeFullName:null,
                ManagerEmployeeId:null,
                ManagerEmployeeFullName:null,
                UAVTCode:null,
                NetsisIsYeri:null,
                OffDay:0,
                //#region NETSIS
                ISYERI:null, //O
                UNVAN:null,
                CADDE:null,
                SOKAK:null,
                KAPINO:null,
                ILCE:null,
                IL:null,
                POSTAKODU:null,
                TELEFON:null,
                BANKASUBE:null,
                BANKAHESAP:null,
                V_DAIRE:null,
                V_HESAPNO:null,//o
                SSK_NO:null,
                TAS_NO:null,
                TEHLIKE:null,
                SINIF:null,
                TEH_ORANI:null,
                SINIF_ORAN:null,
                GUNLUK_SAAT:null,
                TASERON:null,
                AYFLAG:null,
                ISKODU:null,
                SIMDIKIAY:null,
                SIMDIKIYIL:null,
                AYICI:null,
                KACAYICI:null,
                HESAPLANDI:null,
                HESAPLANACAK:null,
                KAZA_HAST:null,
                DEFHESAP:null,
                YUVARLAMABAZI:null,
                BANKAKODU1:null,
                BANKAKODU2:null,
                BANKAKODU3:null,
                MALIMUSAVIR_KODU:null,
                SSK_SEKTOR:null,//o
                SSK_MESLEK:null,//o
                SSK_SUBE:null,//o
                SSK_DOSYANO:null,//o
                SSK_IL:null,//o
                SSK_ILCE:null,//o
                BOLGE_SSK:null,
                YAPILAN_IS:null,
                SSK_SUBE_ADI:null,
                GIZLI:"H",
                SUBE_KODU:null,
                TICARETSICNO:null,//O
                KURULUSTAR:null, //O
                ISKURBIRIMI:null, //O
                ISLETME_KODU:null,
                MERKEZ:null,
                MADENMALULORAN:null,
                MADENISKAZAORAN:null,
                DISERISIM:"E",
                ISKURDOSYANO:null,//o
                IZINAY:null,
                IZINYIL:null,
                SP_YEDEK1:null,
                SP_YEDEK2:null,
                FP_YEDEK1:null,
                FP_YEDEK2:null,
                CP_YEDEK1:null,
                CP_YEDEK2:null,
                BP_YEDEK1:null,
                IP_YEDEK1:null,
                LP_YEDEK1:null,
                MALULORAN:null,
                FAX:null,
                EPOSTA:null,
                WEB:null,
                ISYERIMERKEZI:null,
                MERSISNO:null,
                ISG_GUID:null,
                SSK_ISZ_ISVR_TESVIK_ORANI:null,
                K7166M8GUNTUTAR:null,
                ISYERI_TURU:null,//o
                ISYERI_SUBE_KODU:null,//o
                TIC_SIC_MUD:null,//o
                NACE_KODU:null,//o
                ISYERI_ADRES_NO:null,//o
                MULKIYET_DURUMU:null,//o
                VD_KODU:null,
                BOLGE:null,
                K7256M28GUNTUTAR:null,
                HazardClassId:null,
                //#endregion
            }
        }
    },
    methods:{
        clearForm(){
            this.editing = false
            this.branch.Id = null
            this.branch.Name = null
            this.branch.IsActive = true
            this.branch.IsAbroad = false
            this.branch.RegistryNumber = null
            this.branch.BranchTypeId = null
            this.branch.SGKBranchUsername = null
            this.branch.SGKBranchCode = null
            this.branch.SGKBranchPassword = null
            this.branch.SGKSystemPassword = null
            this.branch.Address = null
            this.branch.AddressDistrictId = null
            this.branch.AddressProvinceId = null
            this.branch.EmployeeId = null
            this.branch.ManagerEmployeeId = null
            this.branch.EmployeeFullName = null
            this.branch.ManagerEmployeeFullName = null
            this.branch.UAVTCode = null
            this.branch.NetsisIsYeri = null
            this.branch.OffDay = 0
            this.branch.HazardClassId = 0
            //#region NETSIS
            this.branch.ISYERI = null
            this.branch.UNVAN = null
            this.branch.CADDE = null
            this.branch.SOKAK = null
            this.branch.KAPINO = null
            this.branch.ILCE = null
            this.branch.IL = null
            this.branch.POSTAKODU = null
            this.branch.TELEFON = null
            this.branch.BANKASUBE = null
            this.branch.BANKAHESAP = null
            this.branch.V_DAIRE = null
            this.branch.V_HESAPNO = null
            this.branch.SSK_NO = null
            this.branch.TAS_NO = null
            this.branch.TEHLIKE = null
            this.branch.SINIF = null
            this.branch.TEH_ORANI = null
            this.branch.SINIF_ORAN = null
            this.branch.GUNLUK_SAAT = null
            this.branch.TASERON = null
            this.branch.AYFLAG = null
            this.branch.ISKODU = null
            this.branch.SIMDIKIAY = null
            this.branch.SIMDIKIYIL = null
            this.branch.AYICI = null
            this.branch.KACAYICI = null
            this.branch.HESAPLANDI = null
            this.branch.HESAPLANACAK = null
            this.branch.KAZA_HAST = null
            this.branch.DEFHESAP = null
            this.branch.YUVARLAMABAZI = null
            this.branch.BANKAKODU1 = null
            this.branch.BANKAKODU2 = null
            this.branch.BANKAKODU3 = null
            this.branch.MALIMUSAVIR_KODU = null
            this.branch.SSK_SEKTOR = null
            this.branch.SSK_MESLEK = null
            this.branch.SSK_SUBE = null
            this.branch.SSK_DOSYANO = null
            this.branch.SSK_IL = null
            this.branch.SSK_ILCE = null
            this.branch.BOLGE_SSK = null
            this.branch.YAPILAN_IS = null
            this.branch.SSK_SUBE_ADI = null
            this.branch.GIZLI = "H"
            this.branch.SUBE_KODU = null
            this.branch.TICARETSICNO = null
            this.branch.KURULUSTAR = null
            this.branch.ISKURBIRIMI = null
            this.branch.ISLETME_KODU = null
            this.branch.MERKEZ = null
            this.branch.MADENMALULORAN = null
            this.branch.MADENISKAZAORAN = null
            this.branch.DISERISIM = "E"
            this.branch.ISKURDOSYANO = null
            this.branch.IZINAY = null
            this.branch.IZINYIL = null
            this.branch.SP_YEDEK1 = null
            this.branch.SP_YEDEK2 = null
            this.branch.FP_YEDEK1 = null
            this.branch.FP_YEDEK2 = null
            this.branch.CP_YEDEK1 = null
            this.branch.CP_YEDEK2 = null
            this.branch.BP_YEDEK1 = null
            this.branch.IP_YEDEK1 = null
            this.branch.LP_YEDEK1 = null
            this.branch.MALULORAN = null
            this.branch.FAX = null
            this.branch.EPOSTA = null
            this.branch.WEB = null
            this.branch.ISYERIMERKEZI = null
            this.branch.MERSISNO = null
            this.branch.ISG_GUID = null
            this.branch.SSK_ISZ_ISVR_TESVIK_ORANI = null
            this.branch.K7166M8GUNTUTAR = null
            this.branch.ISYERI_TURU = null
            this.branch.ISYERI_SUBE_KODU = null
            this.branch.TIC_SIC_MUD = null
            this.branch.NACE_KODU = null
            this.branch.ISYERI_ADRES_NO = null
            this.branch.MULKIYET_DURUMU = null
            this.branch.VD_KODU = null
            this.branch.BOLGE = null
            this.branch.K7256M28GUNTUTAR = null
            //#endregion
        },
        createNew(){
            this.clearForm()
            this.$showModal('create-or-update')
        },
        provider(data){
            return CompanyApi.Branch.Table(data)
        },
        edit(item){
            this.clearForm()
            this.editing = true
            this.branch.Id = item.Id
            this.branch.Name = item.Name
            this.branch.IsActive = item.IsActive
            this.branch.IsAbroad = item.IsAbroad
            this.branch.RegistryNumber = item.RegistryNumber
            this.branch.BranchTypeId = item.BranchTypeId
            this.branch.SGKBranchUsername = item.SGKBranchUsername
            this.branch.SGKBranchCode = item.SGKBranchCode
            this.branch.SGKBranchPassword = item.SGKBranchPassword
            this.branch.SGKSystemPassword = item.SGKSystemPassword
            this.branch.Address = item.Address
            this.branch.AddressDistrictId = item.AddressDistrictId
            this.branch.AddressProvinceId = item.AddressProvinceId
            this.branch.EmployeeId = item.EmployeeId
            this.branch.EmployeeFullName = item.EmployeeFullName
            this.branch.ManagerEmployeeId = item.ManagerEmployeeId
            this.branch.ManagerEmployeeFullName = item.ManagerEmployeeFullName
            this.branch.UAVTCode = item.UAVTCode
            this.branch.NetsisIsYeri = item.NetsisIsYeri
            this.branch.HazardClassId = item.HazardClassId >= 0 ? item.HazardClassId : null
            this.branch.OffDay = item.OffDay
            this.$showModal('create-or-update')
        },
        createOrUpdate(){
            this.loading = true
            CompanyApi.Branch.CreateOrUpdate(this.editing,this.branch).then(res=>{
                this.$result(res)
                this.loading = false
                if(res.data.Success){
                    this.$hideModal('create-or-update')
                    this.$refs.table.refresh()
                }
            }).catch(err=>{
                this.loading = false
                this.$result(null,err)
            })
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.Name} şubesini silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    CompanyApi.Branch.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        },
    }
}
</script>
